import InvestorDocumentsPage from "./InvestorDocumentsPage"

export default InvestorDocumentsPage
